import axios from 'axios'
import { useQuery } from 'react-query'

export interface MarketingCTA {
  image_url: string
  link: string | null
  active?: boolean
}

const SHEET_ID = '1ew1J62ESZxgRDDgj3CF5ogYBMTpmNJx-Ug4_zIsjBnY'

const fetchMarketingCTAs = async (): Promise<MarketingCTA[]> => {
  try {
    const response = await axios.get(
      `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:csv&sheet=content`,
      {
        headers: {
          Accept: 'text/csv',
        },
        timeout: 10000,
      },
    )

    const csvData = response.data
    const rows = csvData
      .split('\n')
      .map((row: string) =>
        row.split(',').map((cell: string) => cell.replace(/^"|"$/g, '').trim()),
      )
      .filter((row: string[]) => row.length > 0 && row[0])

    return rows
      .slice(1)
      .filter((row: string[]) => row[0] && row[0].trim())
      .map((row: string[]) => ({
        image_url: row[0]?.trim() || '',
        link: row[1]?.trim() || null,
        active: true,
      }))
  } catch (_error) {
    return [
      {
        image_url: '/src/features/auth/assets/askyogi-marketing.jpeg',
        link: null,
        active: true,
      },
    ]
  }
}

export const useMarketingCTAs = (): ReturnType<
  typeof useQuery<MarketingCTA[], Error>
> => {
  return useQuery<MarketingCTA[], Error>('marketing-ctas', fetchMarketingCTAs, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    onError: (_error) => {},
  })
}
